import { PaginationType } from './general';

export enum PROMOTION_STATUS {
	PENDING = 'pending',
	ACTIVE = 'active',
	COMPLETED = 'completed'
}

export type PromotionType = {
	id: string;
	main: boolean;
	start_date: string;
	end_date: string;
	name: string;
	description: string;
	status: PROMOTION_STATUS;
	image: string | null;
};

export type UserPromotionType = {
	id: string;
	start_date: string;
	end_date: string;
	name: string;
	tickets_count: number;
	status: PROMOTION_STATUS;
};

export type UserPromotionCardType = {
	id: string;
	main: boolean;
	start_date: string;
	end_date: string;
	name: string;
	description: string;
	status: PROMOTION_STATUS;
	image: string | null;
	position: number;
	multiple_prize: boolean;
	prize: {
		name: string;
		winners: PromotionSimpleWinnerType[];
	};
};

export type PromotionTicketType = {
	id: string;
	item_type: string;
	name: string;
	description: string;
	price: number;
	limit_24h: number;
	limit_per_user: number;
	initial_amount: number;
	amount_left: number;
	game: string | null;
	rarity: string | null;
	rea_bonus_type: string | null;
	items_in_stock: number;
	infinite_stock: boolean;
	lottery_id: string;
	image: string | null;
};

export type PromotionWinnerType = {
	prize_name: string;
	position: number;
	user_pm_id: string;
	is_current_user_winner?: boolean;
};

export type PromotionSimpleWinnerType = {
	position: number;
	user_pm_id: string;
};

export type PromotionPrizeType = {
	position: number;
	name: string;
	description: string;
	image: string | null;
	winners: PromotionSimpleWinnerType[];
};

export type PromotionParticipantsType = {
	subscribed_at: string;
	user_pm_id: string;
};

export type PromotionDetailedType = {
	id: string;
	main: boolean;
	start_date: string;
	end_date: string;
	name: string;
	description: string;
	status: PROMOTION_STATUS;
	image: string | null;
	ticket?: PromotionTicketType;
	subscriptions: PromotionParticipantsType[];
	winners?: PromotionWinnerType[];
	prizes?: PromotionPrizeType[];
	multiple_prize?: boolean;
	current_user_winner?: PromotionWinnerType | null;
	pagination: PaginationType;
};
